import { styled } from "styled-components";

export const Subtitle = styled.p`
  margin: 0;
  color: rgb(105, 113, 117);
  font-size: 18px;
`;
